import { prepareHttpHeaders } from "../utils/http";
import env from "../utils/env";

export default function getConsultState(consultation_id) {
  return fetch(`${env("BASE_URL")}consult_status`, {
    method: "POST",
    headers: prepareHttpHeaders(),
    body: JSON.stringify({ consultation_id })
  }).then(res => {
    if (!res.ok) {
      throw new Error(`Failed to fetch ${env("BASE_URL")}consult_status`);
    }
    return res.json();
  });
}
